document.addEventListener("DOMContentLoaded", function() {

  function findField(key) {
    return document.querySelector('[data-cf-column-key="' + key + '"]')
        || document.querySelector('[data-cf-column-key="' + key + '_1"]');
  }

  // 1. Get URL params
  const params = new URLSearchParams(window.location.search);
  const utmValues = {
    source:   params.get('utm_source')   || '',
    medium:   params.get('utm_medium')   || '',
    campaign: params.get('utm_campaign') || '',
    content: params.get('utm_content') || ''
  };

  if (!utmValues.source && !utmValues.medium && !utmValues.campaign) return;

  // 2. Work with Native Value Setter
  function setNativeValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
        valueSetter.call(element, value);
    }

    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // 3. Main function
  function fillUtmFields() {
    const sourceInput   = findField('utm_source');
    const mediumInput   = findField('utm_medium');
    const campaignInput = findField('utm_campaign');
    const contentInput = findField('utm_content');

    if (sourceInput && mediumInput && campaignInput) {
      if (utmValues.source)   setNativeValue(sourceInput,   utmValues.source);
      if (utmValues.medium)   setNativeValue(mediumInput,   utmValues.medium);
      if (utmValues.campaign) setNativeValue(campaignInput, utmValues.campaign);
      if (utmValues.content) setNativeValue(contentInput, utmValues.content)
      return true;
    }
    return false;
  }

  // 4. Polling
  let attempts = 0;
  const intervalId = setInterval(function() {
    if (fillUtmFields() || ++attempts >= 30) clearInterval(intervalId);
  }, 500);

});
